/** Line-chart config, grouped so members are accessed as `LineChartConstants.x` (no clash with other charts' constants). */
export const LineChartConstants = {
  pointRadius: 4,
  lineTension: 0.3,
  borderWidth: 2,
} as const;
